import { StorageResource } from "../../../../infrastructure/StorageResource";

const themeStorageResource = new StorageResource('@themes');

export default themeStorageResource;